import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
} from "reactstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { 
  getUserCreditById,
  getUserCreditTransactionsById
} from "../../helpers/fakebackend_helper";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { useParams, Link } from "react-router-dom";

const UserTransactions = () => {
  const { userId } = useParams();
  const [userData, setUserData] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUserCredit();
    fetchTransactions();
  }, [userId]);

  const fetchUserCredit = async () => {
    setLoading(true);
    try {
      const response = await getUserCreditById(userId);
      setUserData({
        user: response.user,
        credit: response.credit
      });
    } catch (error) {
      console.error("Error fetching user credit data:", error);
      toastr.error("Failed to fetch user credit data");
    } finally {
      setLoading(false);
    }
  };

  const fetchTransactions = async () => {
    setLoading(true);
    try {
      const response = await getUserCreditTransactionsById(userId);
      setTransactions(response.transactions || []);
    } catch (error) {
      console.error("Error fetching transactions:", error);
      toastr.error("Failed to fetch transactions");
    } finally {
      setLoading(false);
    }
  };

  const getBadgeColor = (type) => {
    switch (type) {
      case "credit_added":
        return "success";
      case "credit_used":
        return "danger";
      case "monthly_free_credit_used":
        return "warning";
      default:
        return "primary";
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  document.title = "User Credit Transactions | Admin";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="User Transactions" pageTitle="Credit Management" />

          {userData && (
            <Row className="mb-4">
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <h4 className="card-title mb-4">User Credit Information</h4>
                    <div className="table-responsive">
                      <table className="table table-bordered mb-0">
                        <tbody>
                          <tr>
                            <th>User ID</th>
                            <td>{userData.user.id}</td>
                            <th>Name</th>
                            <td>{userData.user.name}</td>
                          </tr>
                          <tr>
                            <th>Email</th>
                            <td>{userData.user.email}</td>
                            <th>Credit Balance</th>
                            <td>{userData.credit.credit_balance}</td>
                          </tr>
                          <tr>
                            <th>Monthly Free Credits</th>
                            <td>{userData.credit.monthly_free_credits}</td>
                            <th>Used Free Credits</th>
                            <td>{userData.credit.monthly_credits_used}</td>
                          </tr>
                          <tr>
                            <th>Next Reset Date</th>
                            <td colSpan="3">
                              {formatDate(userData.credit.monthly_credits_reset_date)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-3">
                      <Link 
                        to="/credit-management" 
                        className="btn btn-primary btn-sm"
                      >
                        Back to Credits List
                      </Link>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Transaction History</h4>
                  <div className="table-responsive">
                    <Table className="table align-middle table-nowrap mb-0">
                      <Thead className="table-light">
                        <Tr>
                          <Th scope="col">ID</Th>
                          <Th scope="col">Type</Th>
                          <Th scope="col">Amount</Th>
                          <Th scope="col">Description</Th>
                          <Th scope="col">Purpose</Th>
                          <Th scope="col">Admin</Th>
                          <Th scope="col">Date</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {loading ? (
                          <Tr>
                            <Td colSpan="7" className="text-center">
                              Loading...
                            </Td>
                          </Tr>
                        ) : transactions.length > 0 ? (
                          transactions.map((transaction, index) => (
                            <Tr key={index}>
                              <Td>{transaction.id}</Td>
                              <Td>
                                <Badge color={getBadgeColor(transaction.type)}>
                                  {transaction.type}
                                </Badge>
                              </Td>
                              <Td>{transaction.amount}</Td>
                              <Td>{transaction.description}</Td>
                              <Td>
                                {transaction.purpose || "N/A"}
                              </Td>
                              <Td>
                                {transaction.admin_id ? `Admin #${transaction.admin_id}` : "N/A"}
                              </Td>
                              <Td>{formatDate(transaction.created_at)}</Td>
                            </Tr>
                          ))
                        ) : (
                          <Tr>
                            <Td colSpan="7" className="text-center">
                              No transactions found
                            </Td>
                          </Tr>
                        )}
                      </Tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

UserTransactions.propTypes = {
  match: PropTypes.object,
};

export default connect(null, null)(UserTransactions); 